import React, { useState } from 'react';
import '@/components/VideosFeedbackModal/feedbackModal.css';
import CloseIcon from '@mui/icons-material/Close';
import Toast from '@/utils/toastManager';

const FeedbackModal = ({ isOpen, onSubmit }) => {
  const [feedback, setFeedback] = useState('');

  const handleSubmit = () => {
    onSubmit(feedback);
    Toast.success('Thank you for your feedback');
    setFeedback('');
  };

  const handleSkip = () => {
    onSubmit('');
  };

  if (!isOpen) return null;

  return (
    <div className="feedback-modal-overlay">
      <div className="feedback-modal-content">
        <div className="feedback-modal-header">
          <h3>Help Us Improve</h3>
          <button className="close-btn" onClick={handleSkip}><CloseIcon/></button>
        </div>
        
        <div className="feedback-modal-body">
          <p>Thanks for your feedback. We’re always working to make our content better for you. Could you tell us what we could do better?</p>
          <div className="character-count">{feedback.length}/500</div>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Your input helps us improve future releases."
            rows={4}
            maxLength={500}
          />
        </div>
        
        <div className="feedback-modal-actions">
          <button className="skip-btn" onClick={handleSkip}>
            Skip
          </button>
          <button className="submit-btn" onClick={handleSubmit}>
            Submit Feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;